type TProps = {
  isClickableRow: boolean;
};

const BASE_STYLES = {
  width: '100%',
  minHeight: 256,
};

const CLICKABLE_STYLES = {
  ...BASE_STYLES,
  '& .MuiDataGrid-row': { cursor: 'pointer' },
};

export default function getDataGridStyles({ isClickableRow }: TProps) {
  if (isClickableRow) {
    return CLICKABLE_STYLES;
  }
  return BASE_STYLES;
}
